import { MutationTree } from "vuex";
import { PositionsState } from ".";
import { Position } from "../../models/positions.model";

export const PositionsMutationTypes = {
  GetPositions: "GET_POSITIONS"
};

export const mutations: MutationTree<PositionsState> = {
  [PositionsMutationTypes.GetPositions](state: PositionsState, payload: Position[]) {
    state.positions = payload;
  }
};
